import auth from 'auth'
import constants from 'config/constants'
import { isLoginExpired } from 'domains/authentication/loginExpiration'
import { useEffect, useState } from 'react'

function useLoginDemoAccount() {
  const [isLoading, setIsLoading] = useState(false)

  const hostname = window.location.hostname
  const shouldLoginDemoAccount = hostname === constants.demoHostname

  useEffect(() => {
    if (shouldLoginDemoAccount) {
      const loginDemoAccount = async () => {
        try {
          setIsLoading(true)
          await auth.demoLogin()
        } catch (error) {
          console.error('Error logging in Demo account', error)
        } finally {
          setIsLoading(false)
        }
      }

      const userInfo = auth.getUserInfoFromToken()
      const userNotloggedIn = !userInfo.exp

      if (userNotloggedIn || isLoginExpired()) {
        loginDemoAccount()
      }
    }
  }, [hostname, shouldLoginDemoAccount])

  return { shouldLoginDemoAccount, isLoading }
}

export default useLoginDemoAccount



// WEBPACK FOOTER //
// ./src/domains/useLoginDemoAccount/index.ts